"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var createdBlock = document.createElement("div");
    createdBlock.classList.add("notification", type);
    var blockTitle = document.createElement("h2");
    blockTitle.classList.add("title");
    blockTitle.textContent = title;
    var blockP = document.createElement("p");
    blockP.textContent = description;
    createdBlock.append(blockTitle, blockP);
    document.body.append(createdBlock);
    createdBlock.style.top = "".concat(posTop, "px");
    createdBlock.style.right = "".concat(posRight, "px");
    setTimeout(function() {
        createdBlock.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.510c4011.js.map
